module.exports = __webpack_public_path__ + "static/media/556JamesPBrawleyDrNW_2018-06-12_177.0b89d99b.jpg";